/* This example requires Tailwind CSS v2.0+ */

import React from "react";


import Header from "../components/Header/Header";

import Intro from "../page-sections/Subscription/Intro";
import Body from "../page-sections/Subscription/Body";
import Footer from "../components/Footer/Footer";
import SEO from "../components/SEO/Subscription/SEO";

export default function Example() {
  return (
    <div>
      <Header />
      <SEO/>
      <Intro />
      <Body />
      <Footer />
    </div>
  );
}
